import React from 'react';

import { RegistrationContext } from '../registration/RegistrationProvider';
import SignUpPage from '../registration/SignUpPage';

/**
 * Set referrer to 'print' for lowercase /signup links.
 * 
 * Note: The referrer data/logging is handled by the RegistrationProvider 
 */
const PrintSignUpController = () => {
  const { setReferrer } = React.useContext(RegistrationContext); 
  setReferrer('print');   
  return <SignUpPage />
}

export default PrintSignUpController;